import { createContext, useContext, useState, useEffect } from 'react';

const MfaContext = createContext();

const MFA_KEYS = {
  mfaVerified: 'passkings-mfa-verified',
};

export function MfaProvider({ children }) {
  const [otpUri, setOtpUri] = useState(null);
  const [otpSecret, setOtpSecret] = useState(null);
  const [mfaMethod, setMfaMethod] = useState(null);
  const [isSettingUp, setIsSettingUp] = useState(false);
  const [mfaVerified, setMfaVerifiedState] = useState(() => {
    const stored = localStorage.getItem(MFA_KEYS.mfaVerified);
    return stored === 'true';
  });

  const setMfaVerified = (verified) => {
    setMfaVerifiedState(verified);
    if (verified) {
      localStorage.setItem(MFA_KEYS.mfaVerified, 'true');
    } else {
      localStorage.removeItem(MFA_KEYS.mfaVerified);
    }
  };

  useEffect(() => {
    if (typeof BroadcastChannel === 'undefined') return;

    const channel = new BroadcastChannel('passentry-auth');
    const handleMessage = (e) => {
      if (e.data === 'logout') {
        setMfaVerifiedState(false);
        localStorage.removeItem(MFA_KEYS.mfaVerified);
      }
    };

    channel.addEventListener('message', handleMessage);
    return () => {
      channel.removeEventListener('message', handleMessage);
      channel.close();
    };
  }, []);

  const startMfaSetup = (method, uri, secret) => {
    setMfaMethod(method);
    setOtpUri(uri);
    setOtpSecret(secret);
    setIsSettingUp(true);
  };

  const completeMfaSetup = () => {
    setIsSettingUp(false);
    setMfaVerified(true);
  };

  const clearMfaSetup = () => {
    setOtpUri(null);
    setOtpSecret(null);
    setMfaMethod(null);
    setIsSettingUp(false);
    setMfaVerified(false);
  };

  const clearMfaOperation = () => {
    setOtpUri(null);
    setOtpSecret(null);
    setMfaMethod(null);
    setIsSettingUp(false);
  };

  const startMfaOperation = () => {
    setIsSettingUp(true);
  };

  const completeMfaOperation = () => {
    setIsSettingUp(false);
  };

  return (
    <MfaContext.Provider
      value={{
        otpUri,
        otpSecret,
        mfaMethod,
        isSettingUp,
        mfaVerified,
        setMfaVerified,
        setIsSettingUp,
        startMfaSetup,
        completeMfaSetup,
        clearMfaSetup,
        clearMfaOperation,
        startMfaOperation,
        completeMfaOperation,
      }}
    >
      {children}
    </MfaContext.Provider>
  );
}

export function useMfa() {
  const context = useContext(MfaContext);
  if (!context) {
    throw new Error('useMfa must be used within a MfaProvider');
  }
  return context;
}
